<template>
  <!-- prettier-ignore -->
  <div
    class="ovp-basket-widget"
    :app-version="$version"
    :app-name="$options.name"
    :app-language="$i18n.locale"
  >
    <ovp-basket-widget
      :options="{ configuratorUrl, source }"
      :state="state"
      is-www
    />

    <ovp-auth />
    <ovp-confirmation />
    <ovp-loading />
    <portal-target
      name="modals"
      multiple
    />
    <ovp-notifications
      :notifications="$notification.list()"
    />
  </div>
</template>

<script>
import Vue from '@/setup'

import OvpAuth from '@/components/Screen/Auth'
import OvpBasketWidget from '@/components/BasketWidget/Container'
import OvpConfirmation from '@/components/Modal/Confirmation'
import OvpNotifications from '@/components/Container/Notifications'
import OvpLoading from '@/components/Container/Loading'

import { ApplicationHelper, LogHelper, SessionHelper, SurveyHelper, SyncHelper } from '@/helpers'

import BasketMixin from '@/mixins/Basket'

import { EVENT_READY, EVENT_DOTCOM_SURVEY_WEBSITE, SOURCE_BASKET_WIDGET } from '@/config/events'
import { STATE_LOADING, STATE_READY, SURVEY_TOUCHPOINT_WEBSITE } from '@/config/constants'

export default Vue.extend({
  name: 'BasketWidget',

  mixins: [BasketMixin],

  components: {
    OvpAuth,
    OvpBasketWidget,
    OvpConfirmation,
    OvpNotifications,
    OvpLoading,
  },

  props: {
    source: {
      type: String,
      default: SOURCE_BASKET_WIDGET,
    },
  },

  data() {
    return {
      state: STATE_LOADING,
    }
  },

  created() {
    ApplicationHelper.initializeClearSequence()

    this.$notification.setTranslator((key, params) => this.$t(key, params))

    this.$EventBus.$once(EVENT_READY, () => {
      this.state = STATE_READY
    })

    this.$session
      .resume(basket => this.$_getBasket(basket))
      .then(basket => SessionHelper.restore(basket))
      .then(_basket => this.$_updateBasketLanguage({ language: this.$i18n.locale }))
      .then(basket => {
        SyncHelper.register()
        return basket
      })
      .catch(() => {
        LogHelper.info(["%cNO BASKET FOUND, BUT THAT'S OK :)", 'color: yellow'])
      })
      .finally(() => {
        this.$EventBus.$emit(EVENT_READY)

        this.$EventBus.$once(EVENT_DOTCOM_SURVEY_WEBSITE, () => {
          SurveyHelper.triggerSurvey({
            touchPoint: SURVEY_TOUCHPOINT_WEBSITE,
            language: this.$i18n.locale.toUpperCase(),
          })
        })
      })
  },
  computed: {
    configuratorUrl() {
      return ApplicationHelper.getDvpUrl(this.$i18n.locale)
    },
  },
})
</script>

<style name="global" scoped>
* {
  & >>> button {
    font-weight: bold;
  }

  & >>> button,
  input,
  select {
    font-family: Open Sans, sans-serif !important;
  }
}
</style>